export default __webpack_public_path__ + "static/media/share_32.d33d8d02.svg";